import {ContentCompetenceApi, ContentCompetenceIndexResponse} from "../generated-api";
import {API_CONFIG} from "app/api-config";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import type {RootState} from "../index";

const competenceApi = new ContentCompetenceApi(API_CONFIG);

export const fetchCompetences = createAsyncThunk<ContentCompetenceIndexResponse[], void, { state: RootState }>(
    'competence/list',
    async () => {
        return await competenceApi.contentCompetencesGet();
    },
    {
        // a small static codebook - fetch it once per session, repeated mounts reuse the cache
        condition: (_, {getState}) => {
            const {isLoaded, isLoading} = getState().competence;
            return !isLoaded && !isLoading;
        }
    }
);

const initialState = {
    items: [] as ContentCompetenceIndexResponse[],
    isLoading: false,
    isLoaded: false,
};

export type CompetenceState = typeof initialState;

export const competenceSlice = createSlice({
    name: 'competence',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCompetences.pending, (state) => {
            return {...state, isLoading: true};
        });
        builder.addCase(fetchCompetences.fulfilled, (state, action) => {
            return {...state, items: action.payload, isLoading: false, isLoaded: true};
        });
        builder.addCase(fetchCompetences.rejected, (state) => {
            // leave isLoaded false so the next mount retries
            return {...state, isLoading: false};
        });
    },
});

export const competenceReducer = competenceSlice.reducer;
